module.exports = __webpack_public_path__ + "da7b3ac31438d967b44e6b5e45125805.jpg";